<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">Izaberi jezik ponude</div>
    </div>
    <div class="card-body">
      <div class="selectgroup w-100">
        <label class="selectgroup-item" *ngFor="let language of languages">
          <input type="radio" 
                 [value]="language.value"
                 [(ngModel)]="selectedLanguage"
                 class="selectgroup-input">
          <span class="selectgroup-button">{{ language.label }}</span>
        </label>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="!selectedLanguage">Preuzmi</button>
    </div>
  </div>
</div>